var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccounts = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 3.5H11V3a1.5 1.5 0 0 0-1.5-1.5h-3A1.5 1.5 0 0 0 5 3v.5H2.5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1ZM6 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5H6V3Zm7.5 1.5V9h-11V4.5h11Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccounts);
export default ForwardRef;